import { FormattingRule } from '@ardoq/perspectives';
import { LabelFormattingInfo } from '@ardoq/data-model';
import {
  createFormattingRule,
  deleteFormattingRule,
  reorderFormattingRules,
  updateFormattingRule,
  createLabelFormatting,
  reorderLabelFormatting,
  deleteLabelFormatting,
  updateLabelFormattingAt,
  showReferenceTypeToggled,
} from 'perspective/perspectiveEditor/perspectivesEditor$/actions';
import { dispatchAction } from '@ardoq/rxbeach';
import * as formattingActions from './viewpointBuilderFormattingActions';

// The formatting action creators are shared with the standalone perspective
// editor, whose own commands stay unnamespaced.
export const getViewpointBuilderFormattingCommands = (namespace: string) => ({
  onFormattingRuleDeleted: (deletedRuleId: string) =>
    dispatchAction(deleteFormattingRule(deletedRuleId), namespace),

  onFormattingRuleReordered: (reorderedGroupingRules: string[]) =>
    dispatchAction(reorderFormattingRules(reorderedGroupingRules), namespace),

  onFormattingRuleUpdated: (
    updatedFormattingRuleId: string,
    updatedFormattingRule: Partial<FormattingRule>
  ) =>
    dispatchAction(
      updateFormattingRule({ updatedFormattingRuleId, updatedFormattingRule }),
      namespace
    ),

  onFormattingRuleAdded: (newFormattingRule: FormattingRule) =>
    dispatchAction(createFormattingRule(newFormattingRule), namespace),

  onLabelFormattingAdded: (labelFormatting: LabelFormattingInfo) =>
    dispatchAction(createLabelFormatting(labelFormatting), namespace),

  onLabelFormattingReordered: (
    reorderedLabelFormatting: LabelFormattingInfo[]
  ) =>
    dispatchAction(reorderLabelFormatting(reorderedLabelFormatting), namespace),

  onLabelFormattingDeleted: (deletedLabelFormattingIndex: number) =>
    dispatchAction(
      deleteLabelFormatting(deletedLabelFormattingIndex),
      namespace
    ),

  onUpdateLabelFormattingAt: (
    index: number,
    value: Partial<LabelFormattingInfo>
  ) => dispatchAction(updateLabelFormattingAt({ index, ...value }), namespace),

  onShowReferenceTypeToggled: (showReferenceType: boolean) =>
    dispatchAction(showReferenceTypeToggled(showReferenceType), namespace),

  getFormattingOptions: (
    payload: formattingActions.GetFormattingOptionsPayload
  ) =>
    dispatchAction(formattingActions.getFormattingOptions(payload), namespace),

  setFormattingRules: (payload: formattingActions.SetFormattingRulesPayload) =>
    dispatchAction(formattingActions.setFormattingRules(payload), namespace),

  setLabelFormatting: (payload: formattingActions.SetLabelFormattingPayload) =>
    dispatchAction(formattingActions.setLabelFormatting(payload), namespace),

  setKeepOriginalColor: (keepOriginalColor: boolean) =>
    dispatchAction(
      formattingActions.setKeepOriginalColor(keepOriginalColor),
      namespace
    ),
});

export type ViewpointBuilderFormattingCommands = ReturnType<
  typeof getViewpointBuilderFormattingCommands
>;
